// src/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; 2024 Practise Tests</p>
    </footer>
  );
}

export default Footer;
